import { Button, CardActions, CardContent, CircularProgress, Link, TextField } from "@mui/material";
import React, { useMemo } from "react";
import { useAlerts, useDialog } from "../../../providers";
import { AuthenticationInstance } from "../../../utils/authenticationClass";
import { DialogHeader } from "../../generics/dialog-header";
import { RegisterDialog } from "./register-dialog";
import { VerifyAccountDialog } from "./verify-account-dialog";

export const LoginDialog = ({ cancel, ok }: { cancel: () => void; ok: (result: any) => void }) => {
  const { open: openDialog } = useDialog();
  const [state, setState] = React.useState({
    username: "",
    password: "",
  });
  const [loading, setLoading] = React.useState(false);
  const { showError, showSuccess } = useAlerts();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setState((curr) => ({
      ...curr,
      [e.target.name]: e.target.value,
    }));
  };

  const isValid = useMemo(() => {
    return state.username.length > 0 && state.password.length > 0;
  }, [state]);

  const handleLogin = async () => {
    setLoading(true);
    AuthenticationInstance.handleSignIn(state)
      .then((res) => {
        if (res === "CONFIRM_SIGN_UP") {
          openDialog({
            component: VerifyAccountDialog,
            props: state,
          });
          cancel();
          return;
        }
        showSuccess("Successfully logged in");
        ok(res);
      })
      .catch((err: Error) => {
        showError(err.message);
      })
      .finally(() => setLoading(false));
  };

  const handleRegister = () => {
    openDialog({
      component: RegisterDialog,
    });
    cancel();
  };
  return (
    <>
      <DialogHeader
        title="Sign In to Your Account"
        subheader={
          <Link
            onClick={handleRegister}
            sx={{
              color: "inherit",
              textDecoration: "underline",
              "&:hover": {
                cursor: "pointer",
              },
            }}
          >
            Don't have an account? Click here to register.
          </Link>
        }
      />
      <CardContent>
        <TextField
          fullWidth
          label="Email or Username"
          margin="normal"
          name="username"
          onChange={handleChange}
          value={state.username}
          autoComplete="username"
          variant="outlined"
        />
        <TextField
          fullWidth
          label="Password"
          margin="normal"
          name="password"
          type="password"
          onChange={handleChange}
          value={state.password}
          autoComplete="current-password"
          variant="outlined"
        />
        <Link href="/" variant="body2">
          Forgot password?
        </Link>
      </CardContent>
      <CardActions sx={{ justifyContent: "space-between" }}>
        <Button variant="text" onClick={cancel} size="small" sx={{ color: "text.secondary" }}>
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={!isValid && !loading}
          onClick={handleLogin}
          startIcon={loading ? <CircularProgress sx={{ color: "inherit" }} size={20} /> : null}
        >
          Login
        </Button>
      </CardActions>
    </>
  );
};
